import React from "react";

export const AppSettings = React.createContext();
export const SiteSettings = React.createContext();
